<template>
  <div>
    <div>
      <p v-if="questions.length == 0">QUESTIONS IS EMPTY</p>
      <QuestionEditor
        v-for="question in questions"
        :payload="{ question: question, resource_type: 'Position', resource_data: payload.position_data, resource_id: payload.position_id }"
        :key="question.designator"
      />
    </div>
  </div>
</template>
<script>
import QuestionEditor from '@/components/QuestionEditor'
export default {
  name: 'position-questions',
  props: ['payload'],
  data () {
    return {
      questions: []
    }
  },
  created () {
    this.$network_utils.getResourceQuestions({
      current_type: 'Position',
      current_resource_id: this.payload.position_id,
      designators: 'is_discrete,seniority,job_title,work_scope,urgency'
    }).then(response => {
      this.questions = response
    })
  },
  components: {
    QuestionEditor
  }
}
</script>
